import { ApiResponse, TokenData, Seniority } from "../models";
import * as http from "./http";
import ApiService from "./service";

export class SeniorityService extends ApiService {
  public async loadAllSeniority() {
    const url = `${this.apiDomain}/api/seniority`;
    const resposne = await http.get<ApiResponse<Seniority[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateSeniority(data: Seniority, id?: string) {
    const url = `${this.apiDomain}/api/seniority/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(url, data, this.store);
    return response.data;
  }

  public async createSeniority(data: Seniority) {
    const url = `${this.apiDomain}/api/seniority`;

    const response = await http.post<ApiResponse<TokenData>>(url, data, this.store);
    return response.data;
  }

  public async deleteSeniority(id?: string) {
    const url = `${this.apiDomain}/api/seniority/${id}`;

    const response = await http.remove<ApiResponse<Seniority>>(url, this.store);
    return response.data;
  }
}
